/**
 * Returns new array instance with unique values.
 * @param arr
 * @returns
 */
function uniq(arr) {
    return [...new Set(arr)];
}
export default uniq;
